// extracted by mini-css-extract-plugin
module.exports = {"image":"rca7A","filter-effect-svg":"_1eMqj","filterEffectSvg":"_1eMqj","shapeCrop":"_1K4Go"};